module.exports = __webpack_public_path__ + "img/fastcharger-request.6fa164d9.png";